<template>
  <div id="app" class="container-fluid pl-0 pr-0">
    <router-view />
  </div>
</template>

<script>

import router from './router'

export default {
  name: 'App',
  components: {
  },
  methods: {
    notLogged(){
      if(!this.$session.has('id')){
        router.push({ path: `/login` })
      }
    }
  },
  mounted(){
    this.notLogged();
  }
}
</script>

<style>
.navbar-dark .navbar-nav .nav-link{
  color:black !important;
  font-size:12pt !important;
}
nav.navbar.navbar-dark.bg-info.navbar-expand-lg{
  background:white !important;
}
.logo{
  height: 30px;
}
.navbar-dark .navbar-toggler{
  color:black;
}
link{
  color:black !important;
}
a{
  
}
</style>
